import { render, staticRenderFns } from "./AdicionarSignatario.vue?vue&type=template&id=29f5dac0"
import script from "./AdicionarSignatario.vue?vue&type=script&lang=js"
export * from "./AdicionarSignatario.vue?vue&type=script&lang=js"
import style0 from "./AdicionarSignatario.vue?vue&type=style&index=0&id=29f5dac0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports